import { createSlice } from '@reduxjs/toolkit';
import { IInvite } from 'interface/invites';

interface State {
  list: IInvite[];
}

const initialState: State = {
  list: [],
};

export const showcaseInviteSlice = createSlice({
  name: 'showcaseInvite',
  initialState,
  reducers: {
    setInviteList(state, action) {
      state.list = action.payload;
    },
  },
});

export const { setInviteList } = showcaseInviteSlice.actions;
export default showcaseInviteSlice.reducer;
